'use strict';
import Util from './util';

const cls = Util.cls;

const config = {
    gridSize: 5,
    sel: {
        draggable: '.dd--draggable',
        dragitem: '.dd--dragitem',
        dragging: '.dd--dragging',
        dragged: '.dd--dragged',
        permanent: '.dd--permanent',
        zone: '.dd--zone',
        zoneHovering: '.dd--zone_hovering',
        zoneRemove: '.dd--zone_remove'
    }
};

const draggingDefault = {
    el: null,
    isCloned: false,
    lastTransform: '',
    offsetMouse: {},
    zone: null,
    timeout: null,
    t0: null
};

let dragging = null;

function resetDragging () {
    dragging = Object.assign({}, draggingDefault);
}

function setupListener () {
    $(document)
        .on('mousedown', config.sel.draggable, onDragStart)
        .on('mouseup touchend', onDragEnd)

        .on('touchstart', config.sel.draggable, (ev) => {
            if(dragging.timeout) return;
            // on touchstart we have to decide whether the user actually started dragging something
            // or just scrolls through the page.

            // save starting touch position and define threshold for scrolling
            let x0 = ev.touches[0].clientX,
                y0 = ev.touches[0].clientY,
                x1 = x0, y1 = y0,
                threshhold = 0;

            // update current mouse position
            $(document).on('touchmove', (ev) => {
                x1 = ev.touches[0].clientX;
                y1 = ev.touches[0].clientY;
            });

            // after the short timeout we decide if the user is scrolling or dragging
            dragging.timeout = setTimeout(() => {
                // we don't need to update our stored mouse position anymore now
                $(document).off('touchmove');

                let deltaX = Math.abs(x1 - x0),
                    deltaY = Math.abs(y1 - y0);

                // dragging
                if (deltaX > deltaY || Math.max(deltaX, deltaY) <= threshhold) onDragStart(ev);
            }, 100);
        })
}

function onDragStart (ev) {
    if (ev.cancelable) ev.preventDefault();
    $(document).off('touchmove');
    if(dragging.timeout) clearTimeout(dragging.timeout);

    let $target = $(ev.currentTarget);

    // calc mouse offset relative to element before it gets cloned / position:fixed / etc.
    let offset = $target.offset(),
        isTouchEv = ev.type === 'touchstart',
        clientX = isTouchEv ? ev.touches[0].clientX : ev.clientX,
        clientY = isTouchEv ? ev.touches[0].clientY : ev.clientY;
    dragging.offsetMouse = {
        x: clientX - offset.left,
        y: clientY - offset.top
    };

    // clone element if it's permanent
    if ($target.hasClass(cls(config.sel.permanent))) {
        let targetStillMustBeCloned = true;

        // dragitem is not self -> select first el with class from children
        if (!$target.hasClass(cls(config.sel.dragitem))) {
            let alternative = $($target.find(config.sel.dragitem)[0]);

            // only take it if there is actually an alternative (otherwise use original draggable)
            if (alternative && alternative.length) {
                $target = alternative.clone().appendTo('body').addClass(cls(config.sel.draggable));
                targetStillMustBeCloned = false;

                // center $target on cursor while dragging
                dragging.offsetMouse = { x: $target.width() / 2, y: $target.height() / 2 };
            } else {
                $target = $target.clone().appendTo('body');
            }
        }
        if (targetStillMustBeCloned) $target = $target.clone().appendTo('body');
        dragging.isCloned = true;

    }

    // save data needed for dragging
    dragging.el = $target;
    dragging.lastTransform = dragging.el.css('transform');
    dragging.t0 = Date.now();

    // switch classes
    $target
        .addClass(cls(config.sel.dragging))
        .removeClass(cls(config.sel.permanent));

    // activate parent zone if $el has one
    let $zone = dragging.el.data('dd-zone') || $target.closest(config.sel.zone);
    // TODO as el is a child of zone, zone:hover is always true
    if ($zone && $zone.length && $zone.is(':hover')) {
        onZoneEnter({ currentTarget: $zone });
    }

    // trigger drag to prevent element replacement onClick
    onDrag(ev);

    // add event listener
    $(document).on('mousemove touchmove', onDrag)
        .on('mouseenter', config.sel.zone, onZoneEnter)
        .on('mouseleave', config.sel.zone, onZoneLeave);

    // trigger public event
    $(document).trigger('dd--dragstart', dragging);
}

function onDragEnd (ev) {
    if (!dragging.el) return;
    let $el = $(dragging.el),
        $zone = (dragging.zone && dragging.zone.length) ? dragging.zone : $el.data('dd-zone');

    // find a zone on touch devices
    if (ev.type === 'touchend' && !$zone) $zone = _getCurrentZone(dragging.el);

    // dragged inside a zone
    if ($zone && $zone.length) {

        // dropped on a remove zone -> remove $el
        if ($zone.hasClass(cls(config.sel.zoneRemove))) {
            $(document).trigger('dd--removeel', dragging);
            $el.remove();
        } else {
            // calc new el offset
            let offsetEl = $el.offset(),
                offsetZone = $zone.offset(),
                xTmp = offsetEl.left - offsetZone.left,
                yTmp = offsetEl.top - offsetZone.top,
                pos = snapToZone($el, $zone, xTmp, yTmp);

            // emit custom event
            $zone.trigger('dd--dragend', dragging);

            // add el to zone
            $el
                .addClass(cls(config.sel.dragged))
                .appendTo($zone)
                .css('transform', `translate(${pos.x}px, ${pos.y}px`);
        }
    }
    // dragged outside a zone
    else {
        if (dragging.isCloned) {
            dragging.el.remove();
        }
        $el.css('transform', dragging.lastTransform);
    }

    let draggingReturned =  Object.assign({}, dragging);

    // reset zone, el and dragging data
    onZoneLeave({ currentTarget: $zone });
    $el
        .removeClass(cls(config.sel.dragging))
        .data('dd-zone', $zone);

    // remove event listeners
    $(document)
        .off('mousemove touchmove', onDrag)
        .off('mouseenter', config.sel.zone, onZoneEnter)
        .off('mouseleave', config.sel.zone, onZoneLeave);

    // trigger public event
    $(document).trigger('dd--dragend', Object.assign({}, draggingReturned));
    resetDragging();
}

function onDrag (ev) {
    if (!dragging.el) return;

    let isTouchEv = ev.type.indexOf('touch') > -1,
        clientX = isTouchEv ? ev.touches[0].clientX : ev.clientX,
        clientY = isTouchEv ? ev.touches[0].clientY : ev.clientY;

    // calc new element position
    let x = Math.round((clientX - dragging.offsetMouse.x) / config.gridSize) * config.gridSize,
        y = Math.round((clientY - dragging.offsetMouse.y) / config.gridSize) * config.gridSize;

    dragging.el.css('transform', `translate(${x}px, ${y}px)`);
}

function _getCurrentZone ($el) {
    if (!$el) return null;
    let offset = $el.offset(),
        elx = offset.left,
        ely = offset.top,
        $zone = null;
    $(config.sel.zone).each((i, z) => {
        if ($zone) return;
        let $z = $(z),
            offset = $z.offset(),
            x0 = offset.left,
            y0 = offset.top,
            x1 = x0 + $z.width(),
            y1 = y0 + $z.height();
        if (x0 <= elx && elx <= x1 && y0 <= ely && ely <= y1) $zone = $z;
    });
    return $zone;
}

function snapToZone ($el, $zone, x, y) {
    if (!$zone || !$zone.length || !$el || !$el.length) return { x, y };
    // make sure el is positioned completely inside the zone

    return {
        x: Math.max(0, Math.min($zone.innerWidth() - $el.outerWidth(), x)),
        y: Math.max(0, Math.min($zone.innerHeight() - $el.outerHeight(), y))
    }
}

function onZoneEnter (ev) {
    const $zone = $(ev.currentTarget);
    $zone.addClass(cls(config.sel.zoneHovering));
    dragging.zone = $zone;
}

function onZoneLeave (ev) {
    const $target = $(ev.currentTarget);
    $target.removeClass(cls(config.sel.zoneHovering));
    const $zone = dragging.zone;
    if ($zone && $zone[0] === $target[0]) dragging.zone = null;
}

$(() => {
    resetDragging();
    setupListener();
});
